<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <!-- FILTRAR -->
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <b-card-title> Selecione a Matrícula </b-card-title>
          <div class="d-flex">
            <div class="col-md-4">
              <b-form-group invalid-feedback="campo obrigatório">
                <multiselect
                  v-model="matricula"
                  placeholder="Selecione"
                  :show-labels="false"
                  :options="optionMatricula"
                  :allow-empty="false"
                  :custom-label="
                    ({ NR_MATRICULA, STATUS_MATRICULA, VL_SALDO }) =>
                      `Nº ${NR_MATRICULA} - ${STATUS_MATRICULA} - Saldo: ${this.$tools.converteReal(
                        VL_SALDO
                      )} `
                  "
                />
              </b-form-group>
            </div>

            <div class="flex-responsive col-md-8">
              <div class="col-md-6 text-start">
                <b-button
                  variant="primary"
                  size="md"
                  class="mx-4"
                  @click="filtrarMatricula()"
                >
                  <i
                    class="mdi mdi-filter-outline font-size-16 align-middle me-1"
                  ></i>
                  Filtrar
                </b-button>
              </div>

              <div class="col-md-6 d-flex justify-content-end text-end">
                <!-- <div v-if="this.ativo == true">
                  <b-button variant="success" @click="confirm"> Integralização </b-button>
                </div> -->

                <div class="col-md-6 text-end">
                  <div class="mx-2" v-if="solicitarDesligamento">
                    <b-button
                      @click="verificarProjetoAtivo()"
                      variant="warning"
                      :disabled="loadingSolicitarDesligamento"
                    >
                      Solicitar Desligamento
                      <b-spinner
                        class="ms-2"
                        small
                        variant="primary"
                        v-if="loadingSolicitarDesligamento"
                      ></b-spinner>
                    </b-button>
                  </div>
                  <div v-if="consultarSolicitacoes">
                    <router-link
                      link
                      :to="'contaCapital/desligamento/solicitacaoDesligamento'"
                    >
                      <b-button> Acompanhar Desligamento </b-button>
                    </router-link>
                  </div>
                </div>
              </div>
              <b-modal
                ref="confirmarDesligamento"
                id="confirmarDesligamento"
                centered
                hide-footer
                hide-header
              >
                <div class="d-flex justify-content-center flex-column">
                  <div class="text-center text-warning">
                    <span
                      ><i
                        class="mdi mdi-information-outline"
                        style="font-size: 65px"
                      ></i
                    ></span>
                  </div>
                  <p class="mx-4">
                    Você está ativo em projeto nesta referência.
                  </p>
                  <p class="mx-4">
                    Portanto, não será possível solicitar o desligamento pois a Unicampo precisa finalizar o processo de encerramento 
                    no projeto antes da solicitação do desligamento.<br />
                    Em caso de dúvidas, entre em contato com a Unicampo.
                  </p>
                  <div class="d-flex justify-content-between">
                    <b-button @click="$bvModal.hide('confirmarDesligamento')">
                      Cancelar
                    </b-button>
                    <router-link
                      :to="'/cooperado/contaCapital/desligamento/confirmacaoDesligamento'"
                    >
                      <!-- <b-button variant="success"> Confirmar </b-button> -->
                    </router-link>
                  </div>
                </div>
              </b-modal>
            </div>
          </div>
        </b-card>
      </div>
    </div>
    <div class="d-flex justify-content-center" v-if="loading">
      <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
    </div>
    <!-- HEADER -->
    <div class="row">
      <div class="col-md-6">
        <b-card class="heightCardHeader" v-if="viewHeader">
          <b-card-title class="mb-5"> Admissão </b-card-title>
          <div class="row my-3">
            <div class="col-md-4 text-center">
              <span class="fs-5">Data Admissão</span>
              <h4 class="text-dark fw-bold img-thumbnail my-2">
                {{ $tools.converteData(this.dadosHeader.DT_ADMISSAO) }}
              </h4>
            </div>
            <div class="col-md-4 text-center">
              <span class="fs-5">Nº Ata</span>
              <h4 class="text-center fw-bold img-thumbnail my-2">
                {{ this.dadosHeader.NR_ATA_ADMISSAO }}
              </h4>
            </div>
            <div class="col-md-4 text-center">
              <span class="fs-5">Data Ata</span>
              <h4 class="text-dark fw-bold img-thumbnail my-2">
                {{ $tools.converteData(this.dadosHeader.DT_REUNIAO_ADMISSAO) }}
              </h4>
            </div>
          </div>
          <div class="row my-3">
            <div class="col-md-4 text-center">
              <span class="fs-5">Cotas Integralizadas</span>
              <h4 class="text-dark fw-bold img-thumbnail my-2">
                {{ this.dadosHeader.QT_COTAS_INTEGRALIZADO }}
              </h4>
            </div>
            <div class="col-md-4 text-center">
              <span class="fs-5">Valor Unitário Cota</span>
              <h4 class="text-center fw-bold img-thumbnail my-2">
                {{ $tools.converteReal(this.dadosHeader.VL_UNITARIO_COTA_INT) }}
              </h4>
            </div>
            <div class="col-md-4 text-center">
              <span class="fs-5">Valor Integralizado</span>
              <h4 class="text-center fw-bold img-thumbnail my-2">
                {{ $tools.converteReal(this.dadosHeader.VL_INTEGRALIZADO) }}
              </h4>
            </div>
          </div>
        </b-card>
      </div>
      <div class="col-md-6">
        <b-card class="heightCardHeader" v-if="viewHeader">
          <b-card-title class="mb-5"> Desligamento </b-card-title>
          <div class="row my-3">
            <div class="col-md-4 text-center">
              <span class="fs-5">Data Desligamento</span>
              <h4
                class="img-thumbnail my-2"
                :class="ativo == true ? 'text-secondary' : 'text-dark fw-bold'"
              >
                {{ $tools.converteData(this.dadosHeader.DT_DESLIGAMENTO) }}
              </h4>
            </div>
            <div class="col-md-4 text-center">
              <span class="fs-5">Nº Ata</span>
              <h4
                class="text-center img-thumbnail my-2"
                :class="ativo == true ? 'text-secondary' : 'text-dark fw-bold'"
              >
                {{ this.dadosHeader.NR_ATA_DESLIGAMENTO }}
              </h4>
            </div>
            <div class="col-md-4 text-center">
              <span class="fs-5">Data Ata</span>
              <h4
                class="img-thumbnail my-2"
                :class="ativo == true ? 'text-secondary' : 'text-dark fw-bold'"
              >
                {{
                  $tools.converteData(this.dadosHeader.DT_REUNIAO_DESLIGAMENTO)
                }}
              </h4>
            </div>
          </div>
          <div class="row my-3">
            <div class="col-md-4 text-center">
              <span class="fs-5">Cotas Resgatadas</span>
              <h4
                class="img-thumbnail my-2"
                :class="ativo == true ? 'text-secondary' : 'text-dark fw-bold'"
              >
                {{ this.dadosHeader.QT_COTAS_RESGATADO }}
              </h4>
              <h5 style="font-size: 10px; font-style: italic;"><strong>Após AGO*</strong></h5>
            </div>
            <div class="col-md-4 text-center">
              <span class="fs-5">Valor Unitário Cota</span>
              <h4
                class="text-center img-thumbnail my-2"
                :class="ativo == true ? 'text-secondary' : 'text-dark fw-bold'"
              >
                {{ $tools.converteReal(this.dadosHeader.VL_UNITARIO_COTA_DES) }}
              </h4>
            </div>
            <div class="col-md-4 text-center">
              <span class="fs-5">Valor Resgatado</span>
              <h4
                class="img-thumbnail my-2"
                :class="ativo == true ? 'text-secondary' : 'text-dark fw-bold'"
              >
                {{ $tools.converteReal(this.dadosHeader.VL_RESGATADO) }}
              </h4>
              <h5 style="font-size: 10px; font-style: italic;"><strong>Após AGO*</strong></h5>
            </div>
          </div>
          <div>
            <p style="font-size: 10px; font-style: italic;">* - O que diz o Estatuto Social em relação à restituição de Conta Capital:
              <br /><br />
              Art. 13: Em qualquer caso de demissão, eliminação e exclusão, o associado tem direito a restituição do capital que integralizou, acrescido de juros e de sobras que tiverem sido creditadas ou a creditar, além de outros créditos em conta corrente, deduzidos os débitos porventura existentes.
              <br /><br />
              §1º - A restituição de que trata este artigo somente pode ser exigida, depois de aprovação do Balanço Geral do exercício, pela Assembleia Geral Ordinária em que o associado tenha sido desligado da Cooperativa;
              <br /><br />
              §2º - O Conselho de Administração da Cooperativa pode determinar que a restituição do Capital e dos juros sobre o capital integralizado, de que trata este artigo, seja feita em parcelas iguais e semestrais até 02 (dois) anos, a partir do exercício financeiro seguinte ao do desligamento do associado;  </p>
          </div>
        </b-card>
      </div>
    </div>
    <!-- TABELA DE SALDO -->
    <div class="row">
      <b-card class="heightCardHeader" v-if="viewSaldo">
        <b-card-title class="mb-5"> Saldo Atual de Conta Capital</b-card-title>
        <b-table
          striped
          foot-clone
          responsive="sm"
          :busy.sync="isLoading"
          :items="tabelaSaldoContaCapital"
          :fields="camposSaldoContaCapital"
        >
          <template #foot()="">
            <h6></h6>
          </template>
          <template #foot(VL_DEBITO)="">
            <span>Saldo Disponível:</span>
          </template>
          <template #foot(VL_SALDO)="">
            <span>{{ $tools.converteReal(saldoDisponivel) }}</span>
          </template>
        </b-table>
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination
              :per-page="perPage"
              :total-rows="totalRows"
              v-model="currentPageSaldo"
              @input="carregarSaldoContaCapital"
            ></b-pagination>
          </ul>
        </div>
      </b-card>
    </div>

    <div class="row">
      <!-- FECHAMENTO CONTA CAPITAL -->
      <div class="col-md-6">
        <b-card class="heightCardHeader" v-if="this.viewFechamento">
          <b-card-title class="mb-5">
            Fechamentos de Conta Capital
          </b-card-title>
          <div class="col-md-12">
            <b-table
              striped
              responsive="sm"
              :per-page="perPage"
              :items="dadosFechamento"
              :fields="camposFechamentoContaCapital"
              :current-page="currentPageFechamento"
            >
              <template #cell(acao)="data">
                <div class="text-center">
                  <b-button
                    variant="primary"
                    size="md"
                    class="me-1"
                    @click="
                      emitirMemoriaCalculo(
                        data.item.ANO_FECHAMENTO,
                        data.item.NR_MATRICULA,
                        data.item.SALDO_ANTERIOR,
                        data.item.SALDO_POSTERIOR
                      )
                    "
                  >
                    <i class="mdi mdi-eye"></i>
                  </b-button>
                </div>
              </template>
            </b-table>
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <ul class="pagination pagination-rounded mb-0">
                <b-pagination
                  total-rows="5"
                  :per-page="perPage"
                  v-model="currentPageFechamento"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </b-card>
      </div>
      <!-- GRAFICO EVOLUÇÃO -->
      <div class="col-md-6">
        <b-card class="heightCardHeader" v-if="this.viewFechamento">
          <b-card-title class="text-center mb-5">
            Evolução Anual da Conta Capital
          </b-card-title>
          <div class="col-md-12">
            <apexchart
              class="apex-color"
              height="350"
              type="bar"
              :series="graficoEvolucacao.series"
              :options="graficoEvolucacao.chart"
            ></apexchart>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>


<script>
import PageHeader from "@/components/page-header";
import Multiselect from "vue-multiselect";
import { montaGraficoEvolucao } from "./data-apex";
import contaCapitalMixin from "@/tools/mixins/contaCapitalMixin";
import Swal from "sweetalert2";


export default {
  mixins: [contaCapitalMixin],
  components: {
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      title: "Demonstrativo de Conta Capital.",
      items: [
        {
          text: "Demonstrativo de Conta Capital",
        },
      ],
      dadosGrafico: [],
      dadosHeader: {},
      graficoEvolucacao: {},
      ativo: false,
      optionMatricula: [],
      matricula: "",
      camposSaldoContaCapital: [
        {
          key: "DT_MOVTO",
          label: "Data",
          class: "alinharCelula",
          formatter: (value) => {
            return this.$tools.converteData(value);
          },
        },
        {
          key: "DS_OPERACAO",
          label: "Item",
          sortable: true,
        },
        {
          key: "QT_COTAS",
          label: "Qtde Cotas",
          class: "alinharCelulaDireita",
          sortable: true,
        },
        {
          key: "QT_DIAS_PREVISAO",
          label: "Dias Juros",
          class: "alinharCelula",
        },
        {
          key: "VL_CREDITO",
          label: "Crédito",
          class: "alinharCelulaDireita",
          formatter: (value) => {
            return this.$tools.converteReal(value);
          },
          sortable: true,
        },
        {
          key: "VL_DEBITO",
          label: "Débito",
          class: "alinharCelulaDireita",
          formatter: (value) => {
            return this.$tools.converteReal(value);
          },
          sortable: true,
        },
        {
          key: "VL_SALDO",
          label: "Saldo",
          class: "alinharCelulaDireita",
          formatter: (value) => {
            return this.$tools.converteReal(value);
          },
          sortable: true,
        },
      ],
      tabelaSaldoContaCapital: [],
      camposFechamentoContaCapital: [
        {
          key: "ANO_FECHAMENTO",
          label: "Ano Fechamento",
          class: "alinharCelula",
        },
        {
          key: "DT_FECHAMENTO",
          label: "Data Fechamento",
          class: "alinharCelula",
        },
        {
          key: "SALDO_ANTERIOR",
          label: "Saldo Pré-Fechamento",
          class: "alinharCelulaDireita",
          formatter: (value) => {
            return this.$tools.converteReal(value);
          },
        },
        {
          key: "SALDO_POSTERIOR",
          label: "Saldo Pós-Fechamento",
          class: "alinharCelulaDireita",
          formatter: (value) => {
            return this.$tools.converteReal(value);
          },
        },
        {
          key: "acao",
          label: "",
        },
      ],
      dadosFechamento: [],
      tabelaFechamentoContaCapital: [],
      loading: false,
      viewHeader: false,
      viewSaldo: false,
      viewFechamento: false,
      saldoDisponivel: 0,
      perPage: 10,
      currentPageSaldo: 1,
      currentPageFechamento: 1,
      totalRows: 0,
      solicitarDesligamento: false,
      consultarSolicitacoes: false,
      loadingSolicitarDesligamento: false,
    };
  },

  async created() {
    this.$tools.fecharMenu();
    this.montacabecalho();
  },

  methods: {
    async montacabecalho() {
      this.optionMatricula = await this.buscarLookup();
      if (this.$store.state.filtroMatricula) {
        this.matricula = this.$store.state.filtroMatricula;
        this.filtrarMatricula();
      }
    },

    confirm() {
      Swal.fire({
        title: "Informações Importantes",
        html: "<ul style='font-size:16px;'><li>Sua Conta Capital não tem liquidez imediata.</li><li>Para resgatar o valor, você deve seguir todos os procedimentos de desligamento e respeitar os prazos conforme previsto no <a href='#' id='showArt13Link'>Art. 13</a> do estatuto social da cooperativa.</li></ul>",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ok",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.isConfirmed) {
          this.$router.push({ path: 'contaCapital/integralizacaoVoluntaria' });
        }
      });

      // Adicionar listener de clique ao link após o alerta ser exibido
      Swal.getPopup().querySelector('#showArt13Link').addEventListener('click', (event) => {
        event.preventDefault();
        this.showArt13();
      });
    },

    showArt13() {
      Swal.fire({
        title: "",
        html: "Art. 13 §2o - O Conselho de Administração da Cooperativa pode determinar que a restituição do Capital e dos juros sobre o capital integralizado, de que trata este artigo, seja feita em parcelas iguais e semestrais até 02 (dois) anos, a partir do exercício financeiro seguinte ao do desligamento do associado.",
        icon: "info",
        confirmButtonColor: "#34c38f",
        confirmButtonText: "Ok"
      });
    },

    async filtrarMatricula() {
      let auxDadosHeader = [];
      this.loading = true;
      this.viewHeader = false;
      this.viewSaldo = false;
      this.viewFechamento = false;
      this.saldoDisponivel = 0;
      auxDadosHeader = await this.buscarHeader(this.matricula.NR_MATRICULA);
      this.dadosHeader = auxDadosHeader[0];
      await this.carregarSaldoContaCapital();
      this.dadosGrafico = await this.buscarGrafico(this.matricula.NR_MATRICULA);
      this.dadosFechamento = await this.buscarFechamento(
        this.matricula.NR_MATRICULA
      );
      try {
        this.graficoEvolucacao = montaGraficoEvolucao(this.dadosGrafico);
        this.tabelaSaldoContaCapital.forEach((el) => {
          this.saldoDisponivel += parseFloat(el.VL_SALDO);
        });

        if (this.dadosHeader.DT_DESLIGAMENTO != null) {
          this.ativo = false;
        } else {
          this.ativo = true;
        }
        this.mostrarCards();
      } catch (err) {
        console.log(err);
      }
      this.$store.commit("FILTRO_CONTA_CAPITAL", this.matricula);
      this.$store.commit(
        "MATRICULA_CONTA_CAPITAL",
        this.matricula.NR_MATRICULA
      );
      await this.verificarDesligamento();
      this.loading = false;
    },

    async verificarDesligamento() {
      try {
        const respSolicitacoes = await this.$http.get(
          "api/desligamento/buscarSolicitacoes/" + this.$store.state.nrMatricula
        );

        if (!respSolicitacoes.data || respSolicitacoes.data.length === 0) {
          this.solicitarDesligamento = this.ativo === true;
          this.consultarSolicitacoes = false;
        } else {
          const solicitacoes = respSolicitacoes.data.sort(
            (a, b) => Number(b.sq_matricula_desligamento) - Number(a.sq_matricula_desligamento)
          );
          const ultimaSolicitacao = solicitacoes[0];
          const statusAcompanhar = ["S", "C", "L", "A"];
          this.consultarSolicitacoes = statusAcompanhar.includes(ultimaSolicitacao.st_desligamento);

          if (ultimaSolicitacao.st_desligamento === "D") {
            this.solicitarDesligamento = this.ativo === true;
          } else {
            this.solicitarDesligamento = false;
          }
        }
      } catch (error) {
        console.error("Erro ao buscar os contatos:", error);
      } finally {
        this.loading = false;
      }
    },

    async verificarProjetoAtivo() {
      this.loadingSolicitarDesligamento = true;
      try {
        const respCooperado = await this.$http.get(
          "api/desligamento/verificarCooperadoProjeto"
        );

        if (respCooperado.data.status_cooperado == "ATIVO") {
          this.$refs.confirmarDesligamento.show();
          return;
        }

        this.$router.push(
          "/cooperado/contaCapital/desligamento/confirmacaoDesligamento"
        );
      } catch (error) {
        console.error("Erro ao buscar os contatos:", error);
      } finally {
        this.loadingSolicitarDesligamento = false;
      }
    },

    mostrarCards() {
      this.viewHeader = true;
      if (this.tabelaSaldoContaCapital.length > 0) {
        this.viewSaldo = true;
      }
      if (this.dadosFechamento.length > 0) {
        this.viewFechamento = true;
      }
    },
    emitirMemoriaCalculo(ano, matricula, saldoAnterior, saldoPosterior) {
      let filtroMemoriaCalculo = [];
      filtroMemoriaCalculo.push(ano),
        filtroMemoriaCalculo.push(matricula),
        filtroMemoriaCalculo.push(saldoAnterior),
        filtroMemoriaCalculo.push(saldoPosterior),
        this.$store.commit("FILTRO_MEMORIA_CALCULO", filtroMemoriaCalculo);
      this.$store.commit("HEADER_MEMORIA_CALCULO", this.dadosHeader);
      this.$store.commit("FECHAMENTO_CONTA_CAPITAL", this.dadosFechamento);
      window.open("contaCapital/calculo");
    },

    async carregarSaldoContaCapital() {
      try {
        const response = await this.buscarSaldo(
          this.matricula.NR_MATRICULA,
          this.currentPageSaldo,
          this.perPage
        );
        this.tabelaSaldoContaCapital = response.data;
        this.totalRows = response.total;
        // this.saldoDisponivel = this.calculaSaldoDisponivel(response.data);
      } catch (error) {
        console.error("Erro ao buscar saldo:", error);
      }
    },
  },
}
</script>
